import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'select-primecap',
  templateUrl: './select-primecap.component.html',
  styleUrls: ['./select-primecap.component.css']
})
export class SelectPrimecapComponent implements OnChanges {

  @Input() placeholder: string = 'Pesquisar Startup';
  @Input() width: string = '100%';
  @Input() dataSource: any[] = [];
  @Input() selectedItem: string;
  @Input() push: boolean = true;

  @Output() selectItem = new EventEmitter<any>();
  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;

  icon: string = "pesquisa";
  control: UntypedFormControl = new UntypedFormControl();
  isOpended = false;
  listaSelect: any[] = [];
  itemListaSelecionado: string = '';
  selectElement: any;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.listaSelect = this.dataSource;

    if (changes.selectedItem) {
      this.itemListaSelecionado = this.selectedItem;
    }
  }

  onFocus(){
    this.isOpended = !this.isOpended
  }

  select(item: any){
    this.selectElement = item;
    if (item?.principal) {
      this.inputRef.nativeElement.value = item.principal
    } else {
      this.inputRef.nativeElement.value = item.nome
    }
    this.selectItem.emit(this.selectElement);
  }

  buscarItem() {
    let termoBuscado: string = this.control.value;

    this.listaSelect = this.dataSource.filter(item => {
      if (item?.principal) {
        if (item?.principal?.toString().toLowerCase().indexOf(termoBuscado.toLowerCase()) !== -1) {
          return true;
        }
      } else {
        if (item?.nome?.toString().toLowerCase().indexOf(termoBuscado.toLowerCase()) !== -1) {
          return true;
        }
      }

      return false;
    });
  }
}

export interface StartupSelectInterface {
  principal?: string;
  auxiliar?: string;
  logo?: string;
}
